import { gql } from "@apollo/client";

export const GET_ID_VERIFICATION_PDF = gql`
query getIDVerificationPDF ($processId: String!) {
    getIDVerificationPDF (processId: $processId) 
  }
`;